/** Turn what people actually type into an address.
 *
 * Nobody types "https://kth.se" — they type "kth.se". Refusing that is the kind
 * of validation that reads as the tool being broken, so a bare host is filled
 * in as https rather than rejected.
 */

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

/** host.tld, optionally with a path/query/fragment, and no whitespace. */
const LOOKS_LIKE_HOST = /^[^\s/?#]+\.[a-z]{2,}(?:[/?#]\S*)?$/i;

/** The address with a scheme, or null when it is not one at all. */
export function withHttpsScheme(input: string): string | null {
	const trimmed = input.trim();
	if (!trimmed) return null;
	if (HAS_SCHEME.test(trimmed)) return trimmed;
	return LOOKS_LIKE_HOST.test(trimmed) ? `https://${trimmed}` : null;
}
